import React, { useCallback, useMemo } from 'react'
import { ChatContextSourceType } from '@trustero/trustero-api-web/lib/chatcontext/chatcontext_pb'
import { ChatContext } from 'src/components/Reusable/ChatContext/useChatContext.hooks'
import { useDocumentManagementPermalink } from 'src/components/PageLayout/Permalink/generatePermalink'
import { ChatContextBooleanSelector } from '../chatContextPanel.components'
import { ExternalLink } from './utils.components'

export type DocumentManagementModalProps = {
  show: boolean
  hide: () => void
  onBack?: () => void
  context: ChatContext
  setContext: (context: ChatContext) => void
}

export const DocumentManagementModal = ({
  show,
  hide,
  onBack,
  context,
  setContext,
}: DocumentManagementModalProps): JSX.Element => {
  const documentManagementPermalink = useDocumentManagementPermalink()

  const onCommit = useCallback(
    (includeAll: boolean) => {
      setContext({
        ...context,
        [ChatContextSourceType.DMS]: {
          ...context[ChatContextSourceType.DMS],
          includeAll,
        },
      })
    },
    [context, setContext],
  )

  const description = useMemo(
    () => (
      <p>
        Select if you want to consider your{' '}
        <ExternalLink to={documentManagementPermalink}>
          document management system integrations
        </ExternalLink>
      </p>
    ),
    [documentManagementPermalink],
  )

  return (
    <ChatContextBooleanSelector
      title="Document Management Systems"
      description={description}
      prompt="Do consider document management system integrations"
      currentSelection={context[ChatContextSourceType.DMS].includeAll}
      onCommit={onCommit}
      show={show}
      hide={hide}
      onBack={onBack}
    />
  )
}
